<script setup lang="ts">
import { computed } from 'vue';
import SharedMonacoEditor from 'src/components/shared/SharedMonacoEditor.vue';

const props = defineProps<{
  context: Record<string, any>
}>();

const value = computed(() => {
  const value = props.context.value ?? {};
  return typeof value === 'string' ? value : JSON.stringify(value, null, 2);
});

function handleChange(value: string) {
  try {
    const parsed = JSON.parse(value);
    props.context.node.input(parsed);
  } catch (error) {
    // Keep the raw value in the editor but don't update the form
    // This allows for incomplete JSON while typing
    console.log('error', error);
  }
}
</script>

<template>
  <div :class="{ 'p-invalid': context.state.validationVisible && !context.state.valid }">
    <SharedMonacoEditor
      :model-value="value"
      language="json"
      @update:modelValue="handleChange"
    />
  </div>
</template>

<style scoped>
.p-invalid :deep(.border-1) {
  border-color: var(--red-500);
}
</style>
